import React from "react";
import {
  cardStyle,
  iconContainerStyle,
  textContainer,
} from "./feedback-card.css";
import { Text } from "@vagastec/ensemble-core";

export function FeedbackCard({
  icon,
  title,
  description,
  secondaryText,
  actions,
  ...rest
}) {
  return (
    <div className={cardStyle} {...rest}>
      <div className={iconContainerStyle}>{icon}</div>
      <div className={textContainer}>
        <Text as="h2" size="sm" weight={600}>
          {title}
        </Text>
        <Text as="p" size="sm">
          {description}
        </Text>
        <Text as="p" size="sm" weight={600}>
          {secondaryText}
        </Text>
      </div>

      <div>{actions}</div>
    </div>
  );
}
